// extracted by mini-css-extract-plugin
module.exports = {"wrapper_handle":"Handler_wrapper_handle__3-OS1","titleHendler":"Handler_titleHendler__1PLJc"};